import { render, staticRenderFns } from "./LPlatePicker.vue?vue&type=template&id=4e5a98c1&scoped=true"
import script from "./LPlatePicker.vue?vue&type=script&lang=js"
export * from "./LPlatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a98c1",
  null
  
)

export default component.exports